import React, { useState } from 'react';
import styles from './RoutesPanel.module.css';

export default function SalespointPicker({ salesPoints, excludeIds = new Set(), onSubmit, onCancel, onRowClick }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [markedOrder, setMarkedOrder] = useState([]);

  const filtered = salesPoints
    .filter(sp => !excludeIds.has(sp.id))
    .filter(sp => !searchQuery || (sp.name || '').toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));

  const toggle = (id) => {
    setMarkedOrder(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  return (
    <div className={styles.pickerContainer}>
      <input
        type="text"
        placeholder="Search salespoints..."
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
        className={styles.pickerSearchInput}
        autoFocus
      />
      <div className={styles.pickerList}>
        {filtered.length === 0 && (
          <div className={styles.pickerEmpty}>No salespoints found</div>
        )}
        {filtered.map(sp => {
          const orderIdx = markedOrder.indexOf(sp.id);
          const isMarked = orderIdx !== -1;
          return (
            <div
                key={sp.id}
                className={`${styles.pickerRow} ${isMarked ? styles.pickerRowMarked : ''}`}
                onClick={() => { toggle(sp.id); if (onRowClick) onRowClick(sp); }}
              >
              <span className={styles.orderBadge}>{isMarked ? orderIdx + 1 : ''}</span>
              <span className={styles.pickerRowName}>{sp.name}</span>
              {sp.phone_num && <span className={styles.pickerRowPhone}>{sp.phone_num}</span>}
            </div>
          );
        })}
      </div>
      <div className={styles.pickerActions}>
        {onCancel && (
          <button type="button" className={styles.cancelBtn} onClick={onCancel}>Cancel</button>
        )}
        <button
          type="button"
          className={styles.submitBtn}
          onClick={() => onSubmit(markedOrder)}
          disabled={markedOrder.length === 0}
        >
          Add {markedOrder.length} salespoint{markedOrder.length !== 1 ? 's' : ''}
        </button>
      </div>
    </div>
  );
}
